export enum LocalStorageKey {
  uid = "uid",
  phone = "phone",
  phoneMemo = "phoneMemo",
  token = "token",
  shareCode = "shareCode",
  shareCodeRegisterUser = "shareCodeRegisterUser",
  isAnimationFinished = "isAnimationFinished",
  showShareCode = "showShareCode",
  newsControlToken = "newsControlToken",
  isRefreshEnd = "isRefreshEnd",
}



export class LocalStorageManagement<V extends unknown> {
  key: LocalStorageKey | undefined;
  value: false | string;

  constructor(key: LocalStorageKey) {
    this.key = key;
    if (localStorage.getItem(this.key)) {
      this.value = localStorage.getItem(this.key) as string;
    } else {
      this.value = false;
    }
  }

  set(val: V, key?: LocalStorageKey) {
    let localStorageKey: LocalStorageKey = this.key as LocalStorageKey;
    if (key) {
      localStorageKey = key;
    }
    this.value = typeof val === "string" ? val : JSON.stringify(val);
    localStorage.setItem(
      localStorageKey,
      typeof val === "string" ? val : JSON.stringify(val)
    );
  }

  get(key?: LocalStorageKey) {
    return localStorage.getItem(key || (this.key as LocalStorageKey));
  }

  isNull(key?: LocalStorageKey) {
    return !localStorage.getItem(key || (this.key as LocalStorageKey));
  }

  remove(key?: LocalStorageKey) {
    let localStorageKey: LocalStorageKey = this.key as LocalStorageKey;
    if (key) {
      localStorageKey = key;
    }
    localStorage.removeItem(localStorageKey);
  }
}


